import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchStats } from '@uncinc/react-searchkit';

import { useDialog } from '@uncinc/uncinc-react-kitchen-sink';

import ButtonWrapper from '../../../ButtonWrapper';

import './style.scss';

export interface SearchAllContentFacetsDialogProps {
  title?: string;
  openButtonLabel?: string;
  closeButtonLabel?: string;
  refineButtonLabel?: string;
  className?: string;
  children: React.ReactNode;
}

const SearchAllContentFacetsDialog: React.FC<SearchAllContentFacetsDialogProps> = (props) => {
  const {
    title,
    openButtonLabel,
    closeButtonLabel,
    refineButtonLabel,
    className,
    children,
  } = props;

  const { t } = useTranslation();
  const {
    dialogIsOpen,
    openDialog,
    closeDialog,
  } = useDialog();

  const classNames = c('SearchAllContent__FacetsDialog', className, {
    'SearchAllContent__FacetsDialog--is-open': dialogIsOpen,
  });

  return (
    <>
      <ButtonWrapper
        className="SearchAllContent__FacetsDialog__open-button"
        type="secondary"
        iconName="filter_alt"
        onClick={openDialog}
      >
        {openButtonLabel || t('searchkit.buttons.open_filters')}
      </ButtonWrapper>

      <div className={classNames}>
        <div className="SearchAllContent__FacetsDialog__wrapper">
          <div className="SearchAllContent__FacetsDialog__inner">
            <div className="SearchAllContent__FacetsDialog__header">
              <h2 className="SearchAllContent__FacetsDialog__title asH5">
                {title || t('searchkit.facets.dialog.title')}
              </h2>

              <ButtonWrapper
                className="SearchAllContent__FacetsDialog__close-button"
                type="icon"
                variant="icon-only"
                iconName="close"
                aria-label={closeButtonLabel || t('searchkit.buttons.close_filters')}
                onClick={closeDialog}
              />
            </div>

            <div className="SearchAllContent__FacetsDialog__content">
              {children}
            </div>

            <div className="SearchAllContent__FacetsDialog__footer">
              <ButtonWrapper
                type="secondary"
                iconName="chevron_right"
                onClick={closeDialog}
              >
                {refineButtonLabel || t('searchkit.buttons.refine')}
                <SearchStats />
              </ButtonWrapper>
            </div>
          </div>
        </div>
        <div className="SearchAllContent__FacetsDialog__backdrop" />
      </div>
    </>
  );
};

export default SearchAllContentFacetsDialog;
